import { useMediaQuery, useTheme } from '@mui/material';
import FormulaEditor from '../../../FormulaEditor';
import FormulaFieldsSwitch from '../../../FormulaFieldsSwitch';
import InfoGuide from '../../../InfoGuide';
import useFormulaSubmit from '../../useFormulaSubmit';
import GenerateButton from '../GenerateButton';
import {
  ButtonContainer,
  Container,
  FormulaEditorContainer,
  FormulaEditorWrapper,
  FormulaFieldsSwitchContainer,
  InfoGuideContainer,
} from './styled';
import MobileAdvancedFormulaPanel from './MobileAdvancedFormulaPanel';

const AdvancedFormulaPanel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const submitFormula = useFormulaSubmit();

  const submitHandler = () => {
    submitFormula();
  };

  if (isMobile) {
    return <MobileAdvancedFormulaPanel />;
  }

  return (
    <Container>
      <FormulaFieldsSwitchContainer>
        <FormulaFieldsSwitch />
      </FormulaFieldsSwitchContainer>
      <FormulaEditorContainer>
        <FormulaEditorWrapper>
          <FormulaEditor />
        </FormulaEditorWrapper>
      </FormulaEditorContainer>
      <InfoGuideContainer>
        <InfoGuide />
      </InfoGuideContainer>
      <ButtonContainer>
        <GenerateButton onClick={submitHandler} />
      </ButtonContainer>
    </Container>
  );
};

export default AdvancedFormulaPanel;
